import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { UserBasic } from "../../../_models/user.model";
import { TransferTaskComponent } from "../transfer-task/transfer-task.component";

@Component({
  selector: "app-user-with-avatar",
  templateUrl: "./user-with-avatar.component.html",
  styleUrls: ["./user-with-avatar.component.scss"],
})
export class UserWithAvatarComponent {
  @Input()
  user: UserBasic;

  @Input()
  selectable: boolean = false;

  @Input()
  showUserText: boolean = false;

  @Input()
  grayBackground: boolean = false;

  selectActive: boolean = true;

  @Output()
  userChanged: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private modalController: ModalController,
    private translateServ: TranslateService
  ) {}

  async changeUser() {
    if (!this.selectable) return;

    let modal = await this.modalController.create({
      component: TransferTaskComponent,
      componentProps: {
        saveTitle: this.translateServ.instant("SAVE"),
      },
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--x-large",
    });

    modal.present();

    let res = await modal.onDidDismiss();
    this.closed.emit();
    if (res.data) {
      this.userChanged.emit(res.data.comment);
    }
  }
}
